import { Header } from './ResponsiveHeader';

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js